import React, { useState, useEffect, useCallback } from "react";
import "./Footer.css";
import PlayCircleOutlinedIcon from "@material-ui/icons/PlayCircleOutline";
import PauseCircleOutlineRoundedIcon from "@material-ui/icons/PauseCircleOutlineRounded";
import { Grid, Slider, Dialog, DialogContent, DialogActions, Button } from "@material-ui/core";
import VolumeDownIcon from "@material-ui/icons/VolumeDown";
import VolumeUpRoundedIcon from "@material-ui/icons/VolumeUpRounded";
import VolumeMuteRoundedIcon from "@material-ui/icons/VolumeMuteRounded";
import VolumeOffRoundedIcon from "@material-ui/icons/VolumeOffRounded";
import { useDataLayerValue } from "./DataLayer";
import PoweredBy from "./Powered";

const API_BASE = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : "https://api.aspiewonder.com";

function EllipsisLoading() {
  const [dots, setDots] = useState(".");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => (prev === "..." ? "." : prev + "."));
    }, 400);

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <p
        style={{
          color: "rgba(255, 255, 255, 0.7)",
          fontSize: 14,
          marginTop: 4,
          display: "flex",
          alignItems: "center",
        }}
      >
        Connecting
        <span
          style={{
            display: "inline-block",
            width: 20,     // enough space for 3 dots
            textAlign: "left",
          }}
        >
          {dots}
        </span>
      </p>
    </div>
  );
}

function Footer({ spotifyApi }) {
	const [
		{ volume, player, playback, token },
		dispatch,
	] = useDataLayerValue();

	const [vol, setVol] = useState(0);
	const [trackUri, setTrackUri] = useState(null);
	const [spotifyUserId, setSpotifyUserId] = useState(null);
	const [isPremium, setIsPremium] = useState(false);

	const [uris, setUris] = useState([]);
	const [totalUris, setTotalUris] = useState(0);
	const [playedPlaylist, setPlayedPlaylist] = useState(false);

	const [isLoading, setIsLoading] = useState(true);

	// popup state
	const [likePopupOpen, setLikePopupOpen] = useState(false);
	const [likedTrackSnapshot, setLikedTrackSnapshot] = useState(null);

	const element = document.body;

	// fetch Spotify user id for backend calls
	useEffect(() => {
		if (!spotifyApi) return;
		spotifyApi.getMe().then((me) => {
			setSpotifyUserId(me?.id)
			setIsPremium(me?.product === "premium");
		}).catch(console.error);
	}, [spotifyApi]);

	useEffect(() => {
		console.log('uris', uris);
		// if (uris.length) return;
		if (!spotifyUserId) return;
		// getJSON(`/playlist/${encodeURIComponent(spotifyUserId)}`).then(data => {
		getJSON(`/tracks/review`).then(data => {
			const newUris = [...data.uris.reverse()];
      // setUris(newUris);
			setTotalUris(data.total || 0);

			const uri = newUris.pop();
			setTrackUri(uri);
			setUris(newUris);

			console.log(newUris, uri);
			setIsLoading(false);
    }).catch(console.error);
	}, [spotifyUserId, trackUri]);

	// useEffect(() => {
	// 	console.log(uris);
	// }, [uris]);

	async function getJSON(path) {
		const res = await fetch(`${API_BASE}${path}`, {
      method: "GET",
      headers: { "Content-Type": "application/json", "token": token }
    });
		// const res = await fetch(`${path}`, { method: "GET" });
		if (!res.ok) throw res;
		return res.json();
	}

	async function postJSON(path, body) {
		const res = await fetch(`${API_BASE}${path}`, {
		// const res = await fetch(`${path}`, {
			method: "POST",
			headers: { "Content-Type": "application/json", "token": token },
			body: JSON.stringify(body || {}),
		});
		if (!res.ok) throw res;
		return res.json();
	}

	const handleBackendError = async (err, context = "") => {
		try {
			const text = await err.text?.();
			console.warn(`Backend error ${context}:`, err.status, text);
			if (err.status === 401) alert("Spotify user not valid for voting.");
			if (err.status === 403) alert("Review is closed during open gate.");
		} catch {
			console.warn(`Backend error ${context}:`, err);
		}
	};

	// get next fair track and play it
	const playNextFair = useCallback(async () => {
		if (!spotifyUserId) return;
		try {

			console.log('playNextFair', uris, trackUri);
			// const data = await getJSON(`/next/${encodeURIComponent(spotifyUserId)}`);
			const newUris = [...uris];

			// if (!newUris.length) {
			// 	alert("No more tracks to review");
			// 	return;
			// }

			const uri = newUris.pop();

			if (!uri) {
				alert("No more tracks to review");
				return;
			}



			// const nextUri = data?.spotify_uri;
			// if (!nextUri) return;
			//
			// setTrackUri(nextUri);
			await spotifyApi.play({ uris: [uri] });
			// if (player) player.resume?.().catch(() => {});
			if (player) player.resume();

			setTrackUri(uri);
			setUris(newUris);
		} catch (err) {
			await handleBackendError(err, "GET /next");
		}
	}, [spotifyUserId, spotifyApi, player, uris]);

	// LIKE: send to backend → show popup → on close play next
	const likeCurrent = useCallback(async () => {
		if (!spotifyUserId) return;
		const uri = trackUri;
		if (!uri) {
			// nothing playing yet → just fetch first
			await playNextFair();
			return;
		}
		try {
			setLikePopupOpen(true);

			// snapshot current track for the popup
			const ct = playback?.track_window?.current_track;
			if (ct) {
				setLikedTrackSnapshot({
					image: ct.album?.images?.[0]?.url,
					name: ct.name,
					artists: (ct.artists || []).map((a) => a.name).join(", "),
				});
			} else {
				setLikedTrackSnapshot(null);
			}

			// await postJSON(`/users/${encodeURIComponent(spotifyUserId)}/like`, { spotify_uri: uri });
			await postJSON(`/tracks/${encodeURIComponent(uri)}/like`);

		} catch (err) {
			// await handleBackendError(err, "POST /users/:id/like");
			await handleBackendError(err, `POST /tracks/${encodeURIComponent(uri)}/like`);
		}
	}, [spotifyUserId, playback]);

	// SKIP: send to backend → immediately next
	const skipCurrent = useCallback(async () => {
		if (!spotifyUserId) return;
		const uri = trackUri;
		if (!uri) {
			await playNextFair();
			return;
		}
		try {
			await playNextFair();
			// await postJSON(`/users/${encodeURIComponent(spotifyUserId)}/skip`, { spotify_uri: uri });
			await postJSON(`/tracks/${encodeURIComponent(uri)}/skip`);
		} catch (err) {
			// await handleBackendError(err, "POST /users/:id/skip");
			await handleBackendError(err, `POST /tracks/${encodeURIComponent(uri)}/skip`);
		}
	}, [spotifyUserId, playNextFair, playback]);

	// popup close → advance to next fair track
	const handleCloseLikePopup = async () => {
		await playNextFair();
		setLikePopupOpen(false);
	};

	// keyboard handlers (optional)
	const keyBoardController = (event) => {
		if (player && event.target === element) {
			if (event.keyCode === 32) {
				event.preventDefault();
				player.togglePlay();
			} else if (event.keyCode === 77) {
				mute(event);
			} else if (event.keyCode === 37) {
				seekPosition(event, ((playback?.position - 5000) * 100) / playback?.duration);
			} else if (event.keyCode === 39) {
				seekPosition(event, ((playback?.position + 5000) * 100) / playback?.duration);
			} else if (event.keyCode === 38) {
				event.preventDefault();
				changeVolume(event, volume + 10);
			} else if (event.keyCode === 40) {
				event.preventDefault();
				changeVolume(event, volume - 10);
			} else if (event.keyCode === 190) {
				// "." as next without vote (optional)
				// playNextFair();
			}
		}
	};

	useEffect(() => {
		element.addEventListener("keydown", keyBoardController);
		return () => element.removeEventListener("keydown", keyBoardController);
	});

	const mute = (event) => {
		if (vol === 0) {
			player.setVolume(0);
			dispatch({ type: "SET_VOLUME", payload: 0 });
			setVol(volume);
		} else {
			player.setVolume(vol / 100);
			dispatch({ type: "SET_VOLUME", payload: vol });
			setVol(0);
		}
	};

	const changeVolume = (event, newVolume) => {
		if (newVolume > 100) newVolume = 100;
		else if (newVolume < 0) newVolume = 0;
		player.setVolume(newVolume / 100);
		dispatch({ type: "SET_VOLUME", payload: newVolume });
	};

	const playPause = (event) => {
		event.preventDefault();
		const uri = trackUri;
		console.log('uri', uri);
		if (!uri) {
			// nothing queued yet — fetch first fair track
			playNextFair();
			return;
		}

		if (playedPlaylist) {
			player.togglePlay();
		} else {
			spotifyApi.play({ uris: [uri] });
			if (player) player.resume();
			setPlayedPlaylist(true);
		}

	};

	const seekPosition = (event, newPosition) => {
		if (!isPremium) {
			// alert("Seeking is available for Spotify Premium users only.");
			return;
		}

		player.seek((newPosition * playback?.duration) / 100);
	};

	const logout = (event) => {
		// Clear the correct localStorage key (App.js uses "spotify_token")
		localStorage.removeItem("spotify_token");
		
		// Use the LOGOUT action which properly resets state
		dispatch({
			type: "SET_TOKEN",
			payload: null,
		});

    // dispatch({
    //   type: "LOGOUT",
    // });
	}

	// optional: keep playback state fresh
	useEffect(() => {
		const interval = setInterval(() => {
			if (player && !playback?.paused) {
				player.getCurrentState().then((state) => {
					dispatch({ type: "SET_CURRENT_PLAYBACK", payload: state });
				});
			}
		}, 250);
		if (playback?.paused) clearInterval(interval);
		return () => clearInterval(interval);
	});

	const current = playback?.track_window?.current_track;
	const progressPct = playback?.duration ? (playback.position * 100) / playback.duration : 0;

	if (isLoading) {
		// loading spinner
		return (
			<div className="footer"
					 style={{justifyContent: "center", alignItems: "center", display: "flex", color: "rgba(255, 255, 255, 0.7)"}}>

        {/**/}

        {/*<div>*/}
        {/*    <p style={{color: "rgba(255, 255, 255, 0.7)", fontSize: 14, marginTop: 4}}>*/}
        {/*    </p>*/}
        {/*</div>*/}
        <EllipsisLoading/>

        <div className="footer__center">
          <div className="footer_buttons">
            <button
              style={skipButtonStyle}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f9fafb';
                e.target.style.color = '#374151';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#282828';
                e.target.style.color = '#eaeaea';
              }}
            >
              Skip
            </button>

            {playback ? (
              playback.paused ? (
                <PlayCircleOutlinedIcon
                  fontSize="large"
                  className="footer__icon"
                  cursor={"pointer"}
                />
              ) : (
                <PauseCircleOutlineRoundedIcon
                  fontSize="large"
                  className="footer__icon"
                  cursor={"pointer"}
                />
              )
            ) : (
              <PlayCircleOutlinedIcon
                fontSize="large"
                className="footer__icon"
                cursor={"pointer"}
              />
            )}

            <button
              style={likeButtonStyle}
              disabled={likePopupOpen}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f9fafb';
                e.target.style.color = '#374151';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#282828';
                e.target.style.color = '#eaeaea';
              }}
            >
              ♥ Like
            </button>
          </div>

          <Slider
            value={progressPct || 0}
            className={"footer__progress"}
          />
        </div>

        <div className="footer__right">
          <Grid container spacing={2}>
            <Grid item>
              {volume > 66 ? (
                <VolumeUpRoundedIcon className="footer__icon" cursor={"pointer"}/>
              ) : volume > 33 ? (
                <VolumeDownIcon className="footer__icon" cursor={"pointer"}/>
              ) : volume > 0 ? (
                <VolumeMuteRoundedIcon className="footer__icon" cursor={"pointer"}/>
              ) : (
                <VolumeOffRoundedIcon className="footer__icon" cursor={"pointer"}/>
              )}
            </Grid>
            <Grid item xs>
              <Slider value={volume}/>
            </Grid>
          </Grid>
        </div>

        {/**/}

        <div style={{ padding: '3rem 2rem' }}></div>

        {/*	loggout button */}
				<button
					onClick={logout}
					style={logoutButtonStyle}
					onMouseEnter={(e) => {
						e.target.style.backgroundColor = '#2a2a2a';
						e.target.style.color = 'white';
					}}
					onMouseLeave={(e) => {
						e.target.style.backgroundColor = '#282828';
						e.target.style.color = 'white';
					}}
				>
					Logout
				</button>

        <PoweredBy/>
      </div>
		);
	}

	if (uris.length === 0 && !trackUri && totalUris > 0) {
		console.log('uris', uris, totalUris);
		// return (
		// 	<div className="footer"
		// 			 style={{justifyContent: "center", alignItems: "center", display: "flex", color: "#9ca3af"}}>
		// 		All done! You have reviewed all {totalUris} {totalUris === 1 ? "track" : "tracks"}.
		// 	</div>
		// );
		return (
			<div className="footer"
					 style={{justifyContent: "center", alignItems: "center", display: "flex", color: "rgba(255, 255, 255, 0.7)"}}>
				<div className="floating-notes">
					<div className="note" style={{left: "10%", animationDelay: "0s"}}>♪</div>
					<div className="note" style={{left: "20%", animationDelay: "2s"}}>♫</div>
					<div className="note" style={{left: "30%", animationDelay: "4s"}}>♪</div>
					<div className="note" style={{left: "40%", animationDelay: "1s"}}>♬</div>
					<div className="note" style={{left: "50%", animationDelay: "3s"}}>♪</div>
					<div className="note" style={{left: "60%", animationDelay: "5s"}}>♫</div>
					<div className="note" style={{left: "70%", animationDelay: "7s"}}>♪</div>
					<div className="note" style={{left: "80%", animationDelay: "6s"}}>♬</div>
					<div className="note" style={{left: "90%", animationDelay: "8s"}}>♪</div>
				</div>

				<div>
					All done! You have reviewed all {totalUris} {totalUris === 1 ? "track" : "tracks"}.
				</div>

        <div style={{ padding: '3rem 2rem' }}></div>

        {/*	loggout button */}
				<button
					onClick={logout}
					style={logoutButtonStyle}
					onMouseEnter={(e) => {
						e.target.style.backgroundColor = '#2a2a2a';
						e.target.style.color = 'white';
					}}
					onMouseLeave={(e) => {
						e.target.style.backgroundColor = '#282828';
						e.target.style.color = 'white';
					}}
				>
					Logout
				</button>

        <PoweredBy/>
      </div>
		);
	}

	return (
		<div className="footer">
			<div className="floating-notes">
				<div className="note" style={{left: "10%", animationDelay: "0s"}}>♪</div>
				<div className="note" style={{left: "20%", animationDelay: "2s"}}>♫</div>
				<div className="note" style={{left: "30%", animationDelay: "4s"}}>♪</div>
				<div className="note" style={{left: "40%", animationDelay: "1s"}}>♬</div>
				<div className="note" style={{left: "50%", animationDelay: "3s"}}>♪</div>
				<div className="note" style={{left: "60%", animationDelay: "5s"}}>♫</div>
				<div className="note" style={{left: "70%", animationDelay: "7s"}}>♪</div>
				<div className="note" style={{left: "80%", animationDelay: "6s"}}>♬</div>
				<div className="note" style={{left: "90%", animationDelay: "8s"}}>♪</div>
			</div>

			{/*<div className="floating-notes">*/}
			{/*	<div className="note" style="left: 10%; animation-delay: 0s;">♪</div>*/}
			{/*	<div className="note" style="left: 20%; animation-delay: 2s;">♫</div>*/}
			{/*	<div className="note" style="left: 30%; animation-delay: 4s;">♪</div>*/}
			{/*	<div className="note" style="left: 40%; animation-delay: 1s;">♬</div>*/}
			{/*	<div className="note" style="left: 50%; animation-delay: 3s;">♪</div>*/}
			{/*	<div className="note" style="left: 60%; animation-delay: 5s;">♫</div>*/}
			{/*	<div className="note" style="left: 70%; animation-delay: 7s;">♪</div>*/}
			{/*	<div className="note" style="left: 80%; animation-delay: 6s;">♬</div>*/}
			{/*	<div className="note" style="left: 90%; animation-delay: 8s;">♪</div>*/}
			{/*</div>*/}

			{/* Popup shown after a like. Closing advances to the next fair track */}
			<Dialog
				open={likePopupOpen}
				onClose={handleCloseLikePopup}
				aria-labelledby="liked-track-dialog"
				fullWidth
				maxWidth="xs"
				className="like-popup"
				style={{borderRadius: 4, paddingBottom: 12}}
			>
				<DialogContent style={{backgroundColor: '#161616', display: "flex", justifyContent: "center", alignItems: "center"}}>
					<div className="footer__left"
							 style={{display: "flex", gap: 12, alignItems: "center", justifyContent: "start", paddingBottom: 12, borderRadius: 8}}>
						<img
							className={`${playback ? "footer__albumLogo" : ""}`}
							src={
								likedTrackSnapshot?.image ||
								current?.album?.images?.[0]?.url ||
								""
							}
							alt=""
							style={{width: 125, height: 125, objectFit: "cover", borderRadius: 4}}
						/>
						<div className="footer__songInfo" style={{overflow: "hidden"}}>
							<h4 style={{
								margin: 0,
								marginBottom: 6,
								whiteSpace: "wrap",
								textOverflow: "ellipsis",
								overflow: "hidden"
							}}>
								{likedTrackSnapshot?.name || current?.name || "Liked"}
							</h4>
							<p style={{
								margin: 0,
								color: "rgba(255, 255, 255, 0.7)",
								whiteSpace: "wrap",
								textOverflow: "ellipsis",
								overflow: "hidden"
							}}>
								{likedTrackSnapshot?.artists ||
									(current?.artists || []).map((a) => a.name).join(", ")}
							</p>
						</div>
					</div>
				</DialogContent>

        {/*<div style={{ padding: '3rem 2rem', backgroundColor: '#161616' }}></div>*/}

        <button
					onClick={handleCloseLikePopup}
					style={{...cancelButtonStyle, borderRadius: 0}}
					onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#f9fafb';
            e.target.style.color = '#374151';
					}}
					onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#282828';
            e.target.style.color = '#eaeaea';
					}}
				>
					Close
				</button>

				{/*<DialogActions*/}
				{/*	style={{*/}
				{/*		backgroundColor: "rgba(0, 0, 0, 0.8)",*/}
				{/*		alignItems: "center",*/}
				{/*		justifyContent: "center",*/}
				{/*		paddingTop: 36,*/}
				{/*		paddingBottom: 24*/}
				{/*	}}*/}
				{/*>*/}
				{/*	<Button onClick={handleCloseLikePopup} style={skipButtonStyle}>*/}
				{/*		Close*/}
				{/*	</Button>*/}
				{/*</DialogActions>*/}
			</Dialog>

			<div>
				{totalUris > 0 && (
					<p style={{color: "rgba(255, 255, 255, 0.7)", fontSize: 14, marginTop: 4}}>
						{uris.length + (trackUri ? 1 : 0)} {uris.length === 0 && trackUri ? "track" : "tracks"} left to review
					</p>
				)}
			</div>

			<div className="footer__center">
				<div className="footer_buttons">
					<button
						onClick={skipCurrent}
						style={skipButtonStyle}
						onMouseEnter={(e) => {
							e.target.style.backgroundColor = '#f9fafb';
							e.target.style.color = '#374151';
						}}
						onMouseLeave={(e) => {
							e.target.style.backgroundColor = '#282828';
							e.target.style.color = '#eaeaea';
						}}
					>
						Skip
					</button>

					{playback ? (
						playback.paused ? (
							<PlayCircleOutlinedIcon
								fontSize="large"
								className="footer__icon"
								onClick={playPause}
								cursor={"pointer"}
							/>
						) : (
							<PauseCircleOutlineRoundedIcon
								fontSize="large"
								className="footer__icon"
								onClick={playPause}
								cursor={"pointer"}
							/>
						)
					) : (
						<PlayCircleOutlinedIcon
							fontSize="large"
							className="footer__icon"
							onClick={playPause}
							cursor={"pointer"}
						/>
					)}

					<button
						onClick={likeCurrent}
						style={likeButtonStyle}
						disabled={likePopupOpen}
						onMouseEnter={(e) => {
							e.target.style.backgroundColor = '#f9fafb';
							e.target.style.color = '#374151';
						}}
						onMouseLeave={(e) => {
							e.target.style.backgroundColor = '#282828';
							e.target.style.color = '#eaeaea';
						}}
					>
						♥ Like
					</button>
				</div>

				<Slider
					value={progressPct || 0}
					onChange={seekPosition}
					className={"footer__progress"}
				/>
			</div>

			<div className="footer__right">
				<Grid container spacing={2}>
					<Grid item>
						{volume > 66 ? (
							<VolumeUpRoundedIcon onClick={mute} className="footer__icon" cursor={"pointer"}/>
						) : volume > 33 ? (
							<VolumeDownIcon onClick={mute} className="footer__icon" cursor={"pointer"}/>
						) : volume > 0 ? (
							<VolumeMuteRoundedIcon onClick={mute} className="footer__icon" cursor={"pointer"}/>
						) : (
							<VolumeOffRoundedIcon onClick={mute} className="footer__icon" cursor={"pointer"}/>
						)}
					</Grid>
					<Grid item xs>
						<Slider value={volume} onChange={changeVolume}/>
					</Grid>
				</Grid>
			</div>

      <div style={{ padding: '3rem 2rem' }}></div>

			{/*	loggout button */}
			<button
				onClick={logout}
				style={logoutButtonStyle}
				onMouseEnter={(e) => {
					e.target.style.backgroundColor = '#f9fafb';
					e.target.style.color = '#374151';
				}}
				onMouseLeave={(e) => {
					e.target.style.backgroundColor = '#282828';
					e.target.style.color = '#eaeaea';
				}}
			>
				Logout
			</button>

      <PoweredBy/>
    </div>
	);
}

export default Footer;

const skipButtonStyle = {
	padding: '6px 16px',
	fontSize: '14px',
	fontWeight: '500',
	border: '1px solid rgba(255, 255, 255, 0.2)',
	borderRadius: '8px',
	cursor: 'pointer',
	transition: 'all 0.2s ease',
	outline: 'none',
	fontFamily: 'inherit',
	backgroundColor: '#282828',
	color: 'white'
};

const likeButtonStyle = {
	padding: '6px 12px',
	fontSize: '14px',
	fontWeight: '500',
	border: '1px solid rgba(255, 255, 255, 0.2)',
	borderRadius: '8px',
	cursor: 'pointer',
	transition: 'all 0.2s ease',
	outline: 'none',
	fontFamily: 'inherit',
	backgroundColor: '#282828',
	color: 'white'
};

const cancelButtonStyle = {
	padding: '6px 16px',
	fontSize: '14px',
	fontWeight: '500',
	border: '1px solid rgba(255, 255, 255, 0.2)',
	borderRadius: '8px',
	cursor: 'pointer',
	transition: 'all 0.2s ease',
	outline: 'none',
	fontFamily: 'inherit',
	backgroundColor: '#282828',
	color: 'white'
};

const logoutButtonStyle = {
	padding: '6px 16px',
	fontSize: '14px',
	fontWeight: '500',
	border: '1px solid rgba(255, 255, 255, 0.2)',
	borderRadius: '8px',
	cursor: 'pointer',
	transition: 'all 0.2s ease',
	outline: 'none',
	fontFamily: 'inherit',
	backgroundColor: '#282828',
	color: 'white'
};
